/// <reference path="configuration.js" />
define('viewmodels/configuration',['plugins/router', 'knockout', 'services/appsecurity', 'services/navigation', 'services/logger', 'durandal/app'], function (router, ko, appsecurity, navigation, logger, app) {

    var childRouter = router.createChildRouter()
        .makeRelative({
            //moduleId: 'viewmodels',
            fromParent: true
        }).map([
            { route: ['', 'ClientDetails'], moduleId: 'viewmodels/configuration/ClientDetails', title: 'Enterprise Details', type: 'config', hash: '#configuration/ClientDetails', nav: true, settings: { caption: 'fa fa-list-alt', another: 'property' } },
            { route: 'OrganizationalLevels', moduleId: 'viewmodels/configuration/OrganizationalLevels', title: 'Organizational Levels', hash: '#configuration/OrganizationalLevels', type: 'config', nav: true, settings: { caption: 'fa fa-tasks', another: 'property' } },
            { route: 'RATaxonomySetup', moduleId: 'viewmodels/configuration/RATaxonomySetup', title: 'Taxonomy Setup', hash: '#configuration/RATaxonomySetup', type: 'config', nav: true, settings: { caption: 'fa fa-tasks', another: 'property' } },
            { route: 'RoleManagement', moduleId: 'viewmodels/configuration/RoleManagement', title: 'Role Managment', hash: '#configuration/RoleManagement', type: 'config', nav: true, settings: { caption: 'fa fa-tasks', another: 'property' } },
            { route: 'UserRole', moduleId: 'viewmodels/configuration/UserRole', title: 'User Management', type: 'config', hash: '#configuration/UserRole', nav: true, settings: { caption: 'fa fa-users', another: 'property' } },
            { route: 'UserGroup', moduleId: 'viewmodels/configuration/UserGroup', title: 'User Group Management', type: 'config', hash: '#configuration/UserGroup', nav: true, settings: { caption: 'fa fa-users', another: 'property' } },
            { route: 'BusinessUnit', moduleId: 'viewmodels/configuration/BusinessUnit', title: 'Business Unit Settings', hash: '#configuration/BusinessUnit', type: 'config', nav: true, settings: { caption: 'fa fa-th', another: 'property' } },
            { route: 'QualitativeSetup', moduleId: 'viewmodels/configuration/QualitativeSetup', title: 'Qualitative Setup', hash: '#configuration/QualitativeSetup', type: 'config', nav: true, settings: { caption: 'fa fa-bars', another: 'property' } },
            { route: 'RisksAreasfactors', moduleId: 'viewmodels/configuration/RisksAreasfactors', title: 'Risk Areas', hash: '#configuration/RisksAreasfactors', type: 'config', nav: true, settings: { caption: 'fa fa-tasks', another: 'property' } },
            { route: 'RiskLevel', moduleId: 'viewmodels/configuration/RiskLevel', title: 'Risk Level', hash: '#configuration/RiskLevel', type: 'config', nav: true, settings: { caption: 'fa fa-tasks', another: 'property' } },
            { route: 'ConfigurationManagement', moduleId: 'viewmodels/configuration/ConfigurationManagement', title: 'Configuration Management', hash: '#configuration/ConfigurationManagement', type: 'config', nav: true, settings: { caption: 'fa fa-tasks', another: 'property' } },
            { route: 'InherentSetup', moduleId: 'viewmodels/configuration/InherentSetup', title: 'Inherent Setup', hash: '#configuration/InherentSetup', type: 'config', nav: true, settings: { caption: 'fa fa-tasks', another: 'property' } },
            { route: 'BlueprintSetup', moduleId: 'viewmodels/configuration/BlueprintSetup', title: 'Blueprint Setup', hash: '#configuration/BlueprintSetup', type: 'config', nav: true, settings: { caption: 'fa fa-tasks', another: 'property' } },
            { route: 'EmailTemplate', moduleId: 'viewmodels/configuration/EmailTemplate', title: 'Email Template', hash: '#configuration/EmailTemplate', type: 'config', nav: true, settings: { caption: 'fa fa-tasks', another: 'property' } },
            { route: 'EmailReminderSetup', moduleId: 'viewmodels/configuration/EmailReminderSetup', title: 'Email Reminder Setup', hash: '#configuration/EmailReminderSetup', type: 'config', nav: true, settings: { caption: 'fa fa-tasks', another: 'property' } },
            { route: 'UserSupportTemplates', moduleId: 'viewmodels/configuration/UserSupportTemplates', title: 'User Support Templates', hash: '#configuration/UserSupportTemplates', type: 'config', nav: true, settings: { caption: 'fa fa-tasks', another: 'property' } },
        ]).buildNavigationModel();

    var ConfigViewModel = {
        navigation: navigation,
        router: childRouter,
        activate: activate,
        attached: attached,
        detached: detached,
        logger: logger,
        appsecurity: appsecurity,
        configurationOptions: ko.computed(function () {
            return ko.utils.arrayFilter(childRouter.navigationModel(), function (route) {
                return route.type == 'config';
            });
        })
    };
    return ConfigViewModel;

    function activate() {
        try {

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in configuration.js';
            logger.logMessage(msg);
        }
    }

    function detached() {
        try {
            $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(4)).removeClass('active');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in configuration.js';
            logger.logMessage(msg);
        }
    };

    function attached() {
        try {
            //ConfigViewModel.appsecurity.GetConfigurationFreeze();
            $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(4)).addClass('active');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in configuration.js';
            logger.logMessage(msg);
        }
    }
});





